function compare(a, b) {
  return a > b ? 1 : a === b ? 0 : -1
}

function compareAppProcesses(processesA, processesB) {
  return (
    // Modules at bottom
    compare(
      Boolean(processesA[0].axm_options.isModule),
      Boolean(processesB[0].axm_options.isModule),
    ) ||
    // Most processes at top
    -compare(processesA.length, processesB.length) ||
    // Fallback to application name
    compare(processesA[0].name, processesB[0].name)
  )
}

function isNonEmptyArray(a) {
  return Array.isArray(a) && a.length > 0
}

export function compareApps(a, b) {
  if (isNonEmptyArray(a.processes) && isNonEmptyArray(b.processes)) {
    const cmp = compareAppProcesses(a.processes, b.processes)
    if (cmp) return cmp
  } else if (isNonEmptyArray(a.processes)) {
    return 1
  } else if (isNonEmptyArray(b.processes)) {
    return -1
  }
  return compare(a.name, b.name)
}
